<div class="flex justify-center mt-2 mb-6"
  *ngIf="meeting">
  <div class="flex-col">
    <div class="w-343 tablet:w-768 laptop:w-912 tablet:px-6">
      <div class="bg-light rounded border-l-6 border-info-200 shadow-mdlight mobile:p-6 tablet:p-8 w-full">
        <div class="tablet:flex tablet:items-center tablet:justify-between">
          <p class="text-4 tablet:text-5 font-medium text-dark leading-24 mobile:mb-3 tablet:mb-0">{{dashboardInfo?.jobTitle}}</p>
          <span class="inline-table tablet:flex tablet:items-center px-5 border border-success-300 bg-success-50 rounded-[37px]">
            <span class="text-success-700 text-[13px] leading-[30px]">Interview Confirmed</span>
          </span>
        </div>
        <hr class="my-7 text-neutral-100">
        <div class="tablet:flex tablet:justify-between">
          <!-- Information -->
          <div>
            <!-- Interview Stage -->
            <div class="flex gap-2 mb-4 ">
                <img class="h-20" src="https://postingpanda.blob.core.windows.net/clientpublicassets/global/content/img/svg/briefcase.svg" alt="Interview Stage">
                <span class="text-4 text-dark leading-24">{{meeting.meetingTitle}}</span>
            </div>
            <!-- Date  -->
            <div class="mb-4">
              <interview-date-widget
                [meeting]="meeting"
              ></interview-date-widget>             
            </div>
            <!-- Time -->
            <div class="mb-4">
              <interview-time-widget
                [meeting]="meeting"
              ></interview-time-widget>
            </div>
            <!-- Location  -->
            <interview-location-widget
            [meeting]="meeting"
            [dashboardInfo]="dashboardInfo"
          ></interview-location-widget>
          </div>
          <!-- Buttons -->
          <div class="flex tablet:items-start gap-2 mobile:mt-7 tablet:mt-0">
            <a
              *ngIf="meeting.interviewType == InterviewType.REMOTE && meeting.location?.remoteUrl && isJoinButtonEnabled(meeting)"
              [href]="meeting.location!.remoteUrl"
              target="_blank"
              class="mobile:w-full hover:bg-neutral-50 active:bg-neutral-200 disabled:border-neutral-100 disabled:cursor-not-allowed disabled:text-neutral-300 text-center whitespace-nowrap inline-block py-4 px-6 border border-neutral-200 text-[14px] text-neutral-600 rounded-base leading-18">
              Join
            </a>
            <button
              type="button"
              *ngIf="meeting.interviewType == InterviewType.REMOTE && meeting.location?.remoteUrl && !isJoinButtonEnabled(meeting)"
              disabled
              class="mobile:w-full hover:bg-neutral-50 active:bg-neutral-200 disabled:border-neutral-100 disabled:cursor-not-allowed disabled:text-neutral-300 text-center whitespace-nowrap inline-block py-4 px-6 border border-neutral-200 text-[14px] text-neutral-600 rounded-base leading-18 tooltip-subject">
                Join
                <div class="tooltip whitespace-pre-line w-[200px] bottom-11 mobile:left-[-30px] tablet:left-[-70px]">
                  <div class="tooltip-content text-left text-3 leading-20">
                    This button will become active closer to your scheduled interview time. Please check back on the day of your interview.
                  </div>
                </div>
            </button>
            <button
              (click)="clickViewDetails(meeting)"
              class="mobile:w-full hover:bg-neutral-50 active:bg-neutral-200 disabled:border-neutral-100 disabled:cursor-not-allowed disabled:text-neutral-300 text-center whitespace-nowrap inline-block py-4 px-6 border border-neutral-200 text-[14px] text-neutral-600 rounded-base leading-18">
                View Details
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
